import { LatLng, LatLngBounds } from '@app/models';
import { ParcelShop, ParcelShopFeatures } from '@app/models';
import { createAction, props } from '@ngrx/store';

export const init = createAction('[ParcelShops] Init');

export const load = createAction('[ParcelShops] Load');

export const loadFromApi = createAction('[ParcelShops/API] Load');

export const loadSuccess = createAction('[ParcelShops] Load Success', props<{ parcelShops: ParcelShop[] }>());

export const loadFailed = createAction('[ParcelShops] Load Failed');

export const setFilterLocation = createAction('[ParcelShops] Set Filter Location', props<{ location: LatLng }>());

export const setFilterBounds = createAction('[ParcelShops] Set Filter Bounds', props<{ bounds: LatLngBounds }>());

export const setFilterFeatures = createAction('[ParcelShops] Set Filter Features', props<{ features: Partial<ParcelShopFeatures> }>());

export const setFilterIsOpen = createAction('[ParcelShops] Set Filter IsOpen', props<{ isOpen: boolean | null }>());

export const startClock = createAction('[UI] Start Clock');
export const updateClock = createAction('[UI] Update Clock');
